<div class="whole-container" [class.view-mode-container]="isViewMode">
  @if (!isViewMode) {
    <div class="header-section">
      <div class="form-header">
        {{title}}
      </div>
      <div class="selection-controls" [class.disable-form]="loader.isLoading || !primaryShopConfig">
        <ng-container *ngTemplateOutlet="header_container"></ng-container>
      </div>
    </div>
    @if (!standaloneMode) {
    <div class="cancel-icon">
      <mat-icon class="cross-icon" title="Close Calculator Window" (click)="cancel()">cancel</mat-icon>
    </div>
    }
  }
  @if (loader.isLoading) {
    <div class="loader-class">
      <mat-spinner color="primary"></mat-spinner>
      <div class="loader-message">{{loader.message}}</div>
    </div>
  }
  @if (errorMessage) {
    <div class="error-container">
      <div class="div-error-icon"><mat-icon>error_outline</mat-icon></div>
      <div class="loader-message">{{errorMessage}}</div>
    </div>
  }
  @if (!errorMessage && costCalculatorForm) {
    <div class="form-container" [formGroup]="costCalculatorForm" [class.fc-linemode]="!isShopMode"
     [class.disable-form]="loader.isLoading" [class.boxed-container]="isViewMode">
      <div class="form-array-class" formArrayName="items">
        @if (!isShopMode) {
          <div class="div-line-table">
            <app-table-template [tableData]="lineTableData" [columnList]="lineColumnList" [loading]="loader.isLoading"
              [validateFn]="validateLine.bind(this)" (actionButtonClicked)="handleLineAction($event)"
              [isBoxedTable]="true" [sortableTable]="false" [editableTable]="!isViewMode" [showFilters]="false"
              [showDeleteButton]="true" [showCaptionPanel]="false" [isPaginationEnabled]="false">
            </app-table-template>
          </div>
        }
        @for (group of items.controls; track group.value; let i = $index) {
          <div class="each-form-row" [formGroupName]="i">
            <div class="row-label span2">{{group.value.label}}</div>
            @if (group.value.display_type !== 'M1') {
              <mat-form-field class="span2">
                <mat-label>Plant</mat-label>
                <mat-select formControlName="plant_id" (selectionChange)="calculateDownTimeCosts(group, 'plant')">
                  <mat-option [value]="null">-- Select Plant --</mat-option>
                  @for (plant of primaryCompany.plantList; track plant.plant_id) {
                    <mat-option [value]="plant.plant_id">{{ plant.plant_name }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
              <mat-form-field class="span3">
                <mat-label>Shop</mat-label>
                <mat-select formControlName="shop_id" (selectionChange)="calculateDownTimeCosts(group, 'shop')">
                  <mat-option [value]="null">-- Select Shop --</mat-option>
                  @for (shop of plantShops[group.getRawValue().plant_id]; track shop.shop_id) {
                    <mat-option [value]="shop.shop_id" [disabled]="shop.shop_id === primaryShop.shop_id">
                      {{ shop.shop_name }}
                    </mat-option>
                  }
                </mat-select>
                <mat-error>
                  @if (control(i, 'shop_id')?.hasError('isExists')) {
                    Shop already selected
                  }
                  @else if (control(i, 'shop_id')?.hasError('required')) {
                    Shop is required
                  }
                </mat-error>
              </mat-form-field>
              <mat-form-field class="span2">
                <mat-label>Actual Downtime (Minutes)</mat-label>
                <input matInput type="number" step="1" formControlName="actual_downtime_minutes" (input)="calculateDownTimeCosts(group)">
                <mat-error>
                  @if (control(i, 'actual_downtime_minutes')?.hasError('required')
                   || control(i, 'actual_downtime_minutes')?.hasError('min')) {
                    Number should be > 0
                  }
                </mat-error>
              </mat-form-field>
              <mat-form-field class="span2">
                <mat-label>Calculated Downtime (Minutes)</mat-label>
                <input matInput type="number" step="0.01" formControlName="downtime_minutes">
              </mat-form-field>
              <mat-form-field class="span2">
                <mat-label>Downtime Cost ($)</mat-label>
                <input matInput type="number" step="0.01" formControlName="downtime_cost">
              </mat-form-field>
            }
            @else {
              <mat-form-field class="span9">
                <mat-label>Description</mat-label>
                <input matInput formControlName="description" (input)="group.get('additional_cost')?.updateValueAndValidity()">
                <mat-error>
                  @if (control(i, 'description')?.hasError('maxlength')) {
                    Description should not exceed 500 characters
                  }
                  @else if (control(i, 'description')?.hasError('required')) {
                    Description is required if Additional Cost is entered
                  }
                </mat-error>
              </mat-form-field>
              <mat-form-field class="span2">
                <mat-label>Additional Cost ($)</mat-label>
                <input matInput type="number" step="0.01" formControlName="additional_cost" (input)="setTotalDownTimeCost(group)">
                <mat-error>
                  @if (control(i, 'additional_cost')?.hasError('required')) {
                    Number should be > 0
                  }
                </mat-error>
              </mat-form-field>
            }
          </div>
        }
      </div>
      @if (!isViewMode) {
        <div class="each-form-row total-row">
          <div class="span4 mode-toggle-cell" [class.disable-form]="loader.isLoading || !primaryShopConfig">
            <p-selectbutton class="mode-toggle" fluid [options]="shopToggleStateOptions" [(ngModel)]="isShopModeToggle"
              optionLabel="label" optionValue="value" [allowEmpty]="false" (onOptionClick)="switchShopMode()"
              [disabled]="loader.isLoading" aria-label="Downtime calculation mode" />
          </div>
          <div class="row-label span5"></div>
          @if (isVehicleAvoidanceAllowed) {
            <mat-form-field class="span2">
              <mat-label>Total Vehicle Avoidance</mat-label>
              <input matInput type="number" step="0.01" formControlName="totalVehicleAvoidance">
            </mat-form-field>
          }
          @else {
            <div class="span2"></div>
          }
          <mat-form-field class="span2">
            <mat-label>Total Downtime Cost ($)</mat-label>
            <input matInput type="number" step="0.01" formControlName="totalDownTimeCost">
          </mat-form-field>
        </div>
      }
    </div>
    @if (!isViewMode && !standaloneMode) {
      <div class="action-buttons">
        <button class="action-button" mat-raised-button color="warn" (click)="cancel()">CANCEL</button>
        <button class="action-button" mat-raised-button color="primary" (click)="onSubmit()">APPLY</button>
      </div>
    }
  }
</div>
<ng-template #header_container>
  <div class="header-container">
    @if (!isShopMode) {
      <button class="action-button add-line" mat-raised-button color="primary" 
        [disabled]="tableComponent?.isEditMode ?? false" (click)="addNewLineItem()">
        Add Line Item
      </button>
    }
  </div>
</ng-template>